module.exports = __webpack_public_path__ + "static/media/letsBegin.873ae32a.mp3";